<template>
    <div class="modl-tab-body check-product-search-tab">
        <div class="modl-body">
            <div v-if="!isOnline"
                 data-testid="offline-message"
                 class="alert alert-danger mt-1 mb-1">
                <i class="fa-solid fa-circle-xmark"></i> {{ l('SEARCH_MODAL.OFFLINE_ERROR') }}
            </div>
            <ProductSearchForm />
        </div>

        <div class="modl-footer">
            <button class="btn btn-lg btn-default cancel-btn"
                    @click="$emit('cancel')">
                {{ l('CANCEL') }}
            </button>
        </div>
    </div>
</template>

<script>
import ProductSearchForm from '@/epos/vue/modals/Search/ProductSearchForm';
import { mapState } from 'vuex';

export default {
    name: 'CheckProductSearchTab',

    components: { ProductSearchForm },

    emits: [
        'cancel',
    ],

    data() {
        return {
            searchResults: null,
        };
    },

    computed: {
        ...mapState(['isOnline']),
    },
};
</script>
